import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const ProtectedAdminRoute = ({ children }) => {
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem('token');
      const userType = localStorage.getItem('userType');
      
      console.log('🔍 ProtectedAdminRoute - Auth check:', {
        hasToken: !!token,
        userType,
        tokenPreview: token ? token.substring(0, 50) + '...' : null
      });
      
      if (!token || userType !== 'admin') {
        console.log('❌ ProtectedAdminRoute - Auth failed, redirecting to /admin/login:', { token: !!token, userType });
        setIsChecking(false);  // Stop spinner before redirect
        navigate('/admin/login', { replace: true });
        return;
      }

      console.log('✅ ProtectedAdminRoute - Auth successful');
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      setIsChecking(false);
    };

    // Add a small delay to avoid race conditions
    const timer = setTimeout(checkAuth, 100);
    return () => clearTimeout(timer);
  }, [navigate]);

  if (isChecking) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-yellow-600"></div>
          <p className="mt-2 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedAdminRoute;